module.exports = __webpack_public_path__ + "static/media/page-16.a5e9af3a.png";